<div class="execucao-orcamentaria">
  <div class="list-info">
    <h4>Exercício orçamentário</h4>
    <div class="fist-line-info">
      <p class="destaque">{{ permission?.execucao_orcamentaria_year }}</p>
      <button type="button" class="btn-back" (click)="voltar()">Voltar</button>
    </div>
  </div>

  <!--<div class="list-info">
    <h4>Valor total estimado</h4>
    <p>{{ infoProjeto?.value }}</p>
  </div>-->
</div>

<div class="tabMenu">
  <tabset>
    <tab heading="Configurar" [active]="activeTab === 'configurar'" (click)="savePageToQueryParams('configurar')">
      <app-detalhe-projeto-execucao-orcamentaria-config [idExecucao]="idExecucao"></app-detalhe-projeto-execucao-orcamentaria-config>
    </tab>

    <tab heading="Habilitar itens" [active]="activeTab === 'itens'" (selectTab)="savePageToQueryParams('itens')">
      <app-detalhe-projeto-execucao-orcamentaria-itens [idExecucao]="idExecucao"></app-detalhe-projeto-execucao-orcamentaria-itens>
    </tab>

    <tab heading="Vincular LOA" *ngIf="permission?.permission_menu" [active]="activeTab === 'loa'" (selectTab)="savePageToQueryParams('loa')">
      <app-detalhe-projeto-execucao-orcamentaria-loa-list [idExecucao]="idExecucao"></app-detalhe-projeto-execucao-orcamentaria-loa-list>
    </tab>

    <tab heading="Visualizar execução" *ngIf="permission?.permission_menu" [active]="activeTab === 'execucao'" (selectTab)="savePageToQueryParams('execucao')">
      <app-detalhe-projeto-execucao-orcamentaria-execucao-edit [idExecucao]="idExecucao"></app-detalhe-projeto-execucao-orcamentaria-execucao-edit>
    </tab>
  </tabset>
</div>

<app-loading [loader]="isLoading"></app-loading>